var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"file"},[_vm._v("\n    选择文件\n    "),_c('input',{attrs:{"type":"file","accept":_vm.accept},on:{"change":function($event){return _vm.handlerUpload($event)}}})]),_vm._v("\n\n  "+_vm._s(_vm.filename)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }